// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Ry1O","title":"Info_title__2OYCv","selects":"Info_selects__qRLds","requiredAsterisk":"Info_requiredAsterisk__fb8Bs"};